import type { SVGProps } from "react";

interface LogoIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

export function LogoIcon({ size = 32, ...props }: LogoIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Left page (verso) */}
      <path
        d="M6 6C6 5.448 6.448 5 7 5H15C15.552 5 16 5.448 16 6V26C16 26.552 15.552 27 15 27H7C6.448 27 6 26.552 6 26V6Z"
        fill="currentColor"
      />
      {/* Right page (recto) */}
      <path
        d="M16 6C16 5.448 16.448 5 17 5H25C25.552 5 26 5.448 26 6V26C26 26.552 25.552 27 25 27H17C16.448 27 16 26.552 16 26V6Z"
        fill="currentColor"
        opacity="0.5"
      />
      {/* Text lines on left page */}
      <line
        x1="8.5"
        y1="10"
        x2="14"
        y2="10"
        stroke="var(--color-bg-primary, #faf8f5)"
        strokeWidth="1"
        strokeLinecap="round"
      />
      <line
        x1="8.5"
        y1="13"
        x2="13"
        y2="13"
        stroke="var(--color-bg-primary, #faf8f5)"
        strokeWidth="1"
        strokeLinecap="round"
        opacity="0.7"
      />
      <line
        x1="8.5"
        y1="16"
        x2="14"
        y2="16"
        stroke="var(--color-bg-primary, #faf8f5)"
        strokeWidth="1"
        strokeLinecap="round"
        opacity="0.5"
      />
      {/* Terracotta accent — pen mark */}
      <line
        x1="20"
        y1="20"
        x2="24"
        y2="24"
        stroke="var(--color-accent-light, #e85d2d)"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="24" cy="24" r="1" fill="var(--color-accent-light, #e85d2d)" />
    </svg>
  );
}
